import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <div className="relative min-h-screen flex flex-col">
      <SEO title="Page Not Found | Crowned Canvas Creations" description="The page you're looking for isn't here." path="/404" noindex />
      <Header />
      <main className="pt-32 md:pt-40 pb-24 flex-1 flex items-center justify-center">
        <div className="max-w-xl mx-auto px-6 text-center">
          <p className="overline">404</p>
          <h1 className="font-serif-display text-5xl md:text-7xl leading-[1] mt-5">
            This page is <span className="italic text-[#D4AF37]">unframed.</span>
          </h1>
          <p className="text-white/60 mt-6 font-light">The masterpiece you&apos;re looking for isn&apos;t here. Let&apos;s get you back to Crowned.</p>
          <Link to="/" className="mt-8 inline-flex items-center gap-3 bg-[#D4AF37] text-black px-7 py-4 text-xs uppercase tracking-[0.22em] font-semibold hover:bg-[#e6c245] transition-all">
            Return Home
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
